import React, { useRef, useEffect, useState } from 'react';
import { CardContent, Typography } from '@mui/material';
import { ResponsiveBar } from '@nivo/bar';
import { formatDollar, formatDollarShort } from "../utilityFunctions";


const processPcoSummary = (pco_summary) => {
  return Object.entries(pco_summary).map(([reason, total]) => ({
    reason,
    total,
  }));
};

const PCOTypeSummary = ( { budgetData } ) => {

  let pco_summary_data = {};
  let totals = [];

  if (budgetData && Object.keys(budgetData).length > 0) {
    pco_summary_data = budgetData['pco_summary'] || {};
    totals = processPcoSummary(pco_summary_data);
  }

  // Defining Values for custom bar label
  const fontSize = '13.5px';
  const fontFamily = 'Titillium We, sans-serif';
  const fontColor = '#093d61'


  return (

    <CardContent style={{maxWidth: '800px', margin: 'auto'}}>
      { budgetData && Object.keys(budgetData).length === 0 ? (
       <div style={{ textAlign: 'center' }}>
          <Typography variant="body1">Please select a project</Typography>
        </div>
      ) : (
      <div style={{ height: '300px'}}>
        <ResponsiveBar
          data={totals}
          keys={['total']}
          indexBy="reason"
          margin={{ top: 10, right: 10, bottom: 65, left: 135 }}
          padding={0.05}
          layout="horizontal"
          colors={['#093d61']}
          borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
          axisTop={null}
          axisRight={null}
          axisBottom={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: -35,
            legend: 'Total ($)',
            legendPosition: 'middle',
            legendOffset: 55,
            format: key => formatDollarShort(key)
          }}
          axisLeft={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
          }}
          labelSkipWidth={60}
          labelSkipHeight={12}
          animate={true}
          motionStiffness={90}
          motionDamping={15}
          borderRadius={5}
          labelTextColor={{
            from: 'color',
            modifiers: [
                [
                    'brighter',
                    '10.0'
                ]
            ]
        }}
        height={300}
        theme={{
          labels: {
            text: {
              fontSize: 13.5,
              fill: '#000000',
            },
          },
          axis: {
            ticks: {
              text: {
                fontSize: 12, 
                fill: '#555555', 
              },
            },
            legend: {
              text: {
                fontSize: 17,
                fill: '#333333',
              },
            },
          },
        }}

        label={(d) => formatDollarShort(d.value)}
        tooltip={(d) => (
          <div style={{ padding: '5px', background: '#333', color: '#fff', borderRadius: '3px', fontFamily: 'Titillium Web, sans-serif' }}>
            <strong>{d.indexValue}</strong>
            <br />
            Total: {formatDollar(d.value)}
          </div>
        )}
        />
      </div>
       ) }
    </CardContent>
  );
};

export default PCOTypeSummary;
